// @ts-nocheck
import { useState, useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/lib/supabase';

interface ParentEditPermissions {
  canEdit: boolean;
  isLoading: boolean;
  relationshipType: string | null;
}

export function useParentEditPermissions(): ParentEditPermissions {
  const { user, profile } = useAuth();
  
  // Try to get athlete context, but don't fail if not available
  let athleteProfileId: string | null = null;
  try {
    const { useAthleteView } = require('@/contexts/AthleteViewContext');
    const athleteContext = useAthleteView();
    athleteProfileId = athleteContext?.athleteProfileId || null;
  } catch (error) {
    // AthleteViewProvider not available (e.g., in public profile view)
    console.log('🔍 useParentEditPermissions: AthleteView context not available');
    // Return default state immediately when context is not available
    return {
      canEdit: false,
      isLoading: false,
      relationshipType: null,
    };
  }
  
  const [permissions, setPermissions] = useState<ParentEditPermissions>({
    canEdit: false,
    isLoading: true,
    relationshipType: null,
  });

  useEffect(() => {
    async function checkPermissions() {
      if (!athleteProfileId || !user?.id || !profile?.id) {
        setPermissions({ canEdit: false, isLoading: false, relationshipType: null });
        return;
      }

      // 🔥 TEMPORARY: Allow edit for all parent access while we debug the database
      console.log('🔥 TEMPORARY OVERRIDE: Allowing parent edit permissions for testing');
      setPermissions({
        canEdit: true,
        isLoading: false,
        relationshipType: 'parent',
      });
      return;

      // Original code commented out for now:
      /*
      try {
        const { data: relationship, error } = await supabase
          .from('parent_athlete_relationships')
          .select('access_level, can_edit_profile, status')
          .eq('parent_profile_id', profile.id)
          .eq('athlete_profile_id', athleteProfileId)
          .maybeSingle();

        if (error) {
          console.error('🔴 Error checking parent permissions:', error);
          setPermissions({ canEdit: false, isLoading: false, relationshipType: null });
          return;
        }

        const isActive = relationship?.status === 'accepted';
        const canEdit = relationship?.can_edit_profile === true && isActive;
        const relationshipType = relationship?.access_level || null;

        setPermissions({
          canEdit,
          isLoading: false,
          relationshipType,
        });
      } catch (error) {
        console.error('🔴 Error in parent edit hook:', error);
        setPermissions({ canEdit: false, isLoading: false, relationshipType: null });
      }
      */
    }

    checkPermissions();
  }, [athleteProfileId, user?.id, profile?.id]);

  return permissions;
}
